import {defineRouting} from 'next-intl/routing';
import {defaultLocale, locales} from './config';

export const routing = defineRouting({
  // Доступные локали для приложения
  locales,
  // Локаль по умолчанию
  defaultLocale,
  // Все локали имеют префикс, включая дефолтную
  // Локаль определяется только из URL, автоматическое определение браузера отключено
  localePrefix: 'always',
  // Отключаем автоматическое определение языка браузера
  // Это предотвращает изменение локали при редиректах на Android устройствах
  localeDetection: false,
});
